import { render } from "./checkboard.vue?vue&type=template&id=53b7bd5a&scoped=true"
import script from "./checkboard.vue?vue&type=script&lang=js"
export * from "./checkboard.vue?vue&type=script&lang=js"

import "./checkboard.vue?vue&type=style&index=0&id=53b7bd5a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\86134\\Desktop\\Web\\Item\\来画设计\\laiiva-web\\packages\\QColor\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b7bd5a"]])

export default __exports__